import { features } from "@/mocks/homeData";

export default function FeaturesSection() {
  return (
    <section className="w-full bg-[#F7F5F2] py-20 md:py-28 lg:py-32">
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-6xl mx-auto">

        <p
          className="text-[11px] uppercase tracking-[0.22em] text-[#6C7278] font-medium"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          / Why Trevionix
        </p>

        <h2
          className="mt-4 text-3xl md:text-4xl lg:text-[48px] font-extrabold text-[#1A1C1E] tracking-[-0.02em] leading-tight"
          style={{ fontFamily: "'Public Sans', sans-serif" }}
        >
          Technology Meets
          <br />
          <span className="font-light text-[#6C7278]">Business Growth</span>
        </h2>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-px bg-[#E2DED9]">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-8 md:p-10 bg-[#F7F5F2] hover:bg-white transition-colors duration-300"
            >
              <div className="w-10 h-10 flex items-center justify-center text-[#B8422E]">
                <i className={`${feature.icon} text-2xl`} />
              </div>
              <h3
                className="mt-6 text-lg font-semibold text-[#1A1C1E] leading-snug"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                {feature.title}
              </h3>
              <p
                className="mt-3 text-sm text-[#6C7278] leading-relaxed"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Stats bar */}
        <div className="mt-px grid grid-cols-3 gap-px bg-[#E2DED9]">
          {[
            { value: "120+", unit: "", label: "Projects Delivered" },
            { value: "35+", unit: "", label: "Expert Team Members" },
            { value: "8+", unit: "yrs", label: "Industry Experience" },
          ].map((stat) => (
            <div key={stat.label} className="bg-[#F7F5F2] px-8 md:px-10 py-8 flex flex-col">
              <p
                className="text-3xl md:text-4xl font-extrabold text-[#1A1C1E] tracking-[-0.02em]"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                {stat.value}
              </p>
              <p
                className="mt-1 text-xs text-[#6C7278] uppercase tracking-[0.12em]"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
